
import SingleSBanner from "../components/Services/SingleSevices/SingleSBanner";
import ServiceContent from "../components/Services/SingleSevices/ServiceContent";
import OtherServices from "../components/Services/SingleSevices/OtherServices";


const SingleService = () => {
  

  return (
    <>
      <SingleSBanner />
      <ServiceContent />
      <OtherServices/>
    </>
  );
};

export default SingleService;
